import { Theme } from '@mui/material'
import { css } from '@emotion/react'

export const sideDrawerDividerStyle = ({ theme }: { theme: Theme }) => css`
  height: 1px;
  width: 100%;
  background-color: ${theme.palette.primary.main}30;
  flex-shrink: 0;
`
